import { router as auth } from './auth';
import { router as catMain } from './cat-main';
import { router as catAssignment } from './cat-assignment';
import { router as catDomain } from './cat-domain';
import { router as catProficiency } from './cat-proficiency';
import { router as VideoLecture } from './video-lecture';
import { router as CardLecture } from './card-lecture';
import { router as Course } from './course';
import { router as Bookmark } from './bookmark';
import { router as DomainLecture } from './domain-lecture';
import { router as UserLicence } from './user-licence';
import errors from './errors';

export default [
  ...auth,
  ...catMain,
  ...catAssignment,
  ...catDomain,
  ...catProficiency,
  ...VideoLecture,
  ...CardLecture,
  ...Course,
  ...Bookmark,
  ...DomainLecture,
  ...errors,
  ...UserLicence,
];



// WEBPACK FOOTER //
// ./src/app/router.js